import { AsiDialogView } from "@asi-ngtools/lib";
import { OnInit, Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ProfilDto, CampagneDto, UserTransformationCompteDto, ICampagneWebServiceClient, IProfilWebServiceClient, IUserTransformationCompteWebServiceClient } from "../../resources/auth/resources.auth";
import { CorrespondantStore } from "../../store/correspondant.store";

declare var document: any;


@Component({
    selector: 'popin-compte-component',
    templateUrl: './popin-compte.component.html',
})
export class PopinCompteComponent extends AsiDialogView implements OnInit {

    canClosePopin: boolean = false;
    profils: ProfilDto[] = [];
    campagne: CampagneDto = new CampagneDto();
    user: UserTransformationCompteDto;
    modelForm: FormGroup;
    cguString: string = "";
    public formattedDate: string = "fr";
    isFr: boolean = true;

    constructor(private fb: FormBuilder,
        private campagneWebService: ICampagneWebServiceClient,
        private userWebService: IUserTransformationCompteWebServiceClient,
        private profilWebService: IProfilWebServiceClient,
        private correspondantStore: CorrespondantStore) {
        super();

        let tags: string[] = [];
        this.correspondantStore.getCorrespondants().forEach(c => {
            tags = tags.concat(c.tags)
        })

        this.isFr = !(tags.indexOf("en") != -1 && tags.indexOf("fr") == -1);
        this.generateCGULabel();
    }

    async ngOnInit() {

        this.modelForm = this.fb.group({
            profil: [null, Validators.required],
            prenom: [null],
            nom: [null],
            email: [null, Validators.required],
            telephone: [null],
            codeRpps: [null],
            acceptEmail: [null],
            acceptCGU: [null, Validators.required]
        });

        this.profils = await this.profilWebService.getAllProfil().toPromise();
        this.user = await this.userWebService.getUserInformationCompte().toPromise();
        if (this.user) {
            this.modelForm.patchValue({
                profil: this.user.profil ? this.profils.find(pro => pro.id == this.user.profil.id) : null,
                prenom: this.user.prenom,
                nom: this.user.nom,
                email: this.user.email,
                telephone: this.user.telephone,
                codeRpps: this.user.codeRpps,
                acceptEmail: this.user.hasAcceptEmail,
                acceptCGU: this.user.hasAcceptCGU,
            })
            this.updateSelectedProfil();
        }

        this.campagne = await this.campagneWebService.getEmailCampagne().toPromise();
        if (!this.campagne.active || !this.campagne.dateFin || this.campagne.dateFin >= new Date()) {
            this.canClosePopin = true;
        }
    }

    ngAfterViewInit() {
        if(false || !!document.documentMode || window.navigator.userAgent.indexOf("Edg") > -1) {
            let elem:any = document.querySelector("#popin-compte form");
            elem.style["flex-basis"] = "auto";
        }
    }

    submit(): void {
        if (!this.modelForm.valid) {
            return;
        }

        let userToSave: UserTransformationCompteDto = new UserTransformationCompteDto();
        userToSave.profil = this.modelForm.value.profil
        userToSave.prenom = this.modelForm.value.prenom
        userToSave.nom = this.modelForm.value.nom
        userToSave.email = this.modelForm.value.email
        userToSave.codeRpps = this.modelForm.value.codeRpps
        userToSave.telephone = this.modelForm.value.telephone
        userToSave.hasAcceptEmail = this.modelForm.value.acceptEmail
        userToSave.hasAcceptCGU = this.modelForm.value.acceptCGU

        this.userWebService.saveFromUserInformationCompte(userToSave).subscribe(() => {
            window.location.reload();
        })
    }

    updateSelectedProfil(): void {
        if (this.modelForm.controls.profil.value) {
            let profil = this.modelForm.controls.profil.value.champs;
            this.modelForm.controls.prenom.setValidators((profil.indexOf("prenom") !== -1 ) ? [Validators.required] : []);
            this.modelForm.controls.nom.setValidators((profil.indexOf("nom") !== -1 ) ? [Validators.required] : []);
            this.modelForm.controls.telephone.setValidators((profil.indexOf("telephone") !== -1 ) ? [Validators.required] : []);
            this.modelForm.controls.codeRpps.setValidators((profil.indexOf("codeRpps") !== -1 ) ? [Validators.required] : []);
        }
        this.modelForm.controls.prenom.updateValueAndValidity();
        this.modelForm.controls.nom.updateValueAndValidity();
        this.modelForm.controls.email.updateValueAndValidity();
        this.modelForm.controls.telephone.updateValueAndValidity();
        this.modelForm.controls.codeRpps.updateValueAndValidity();
    }

    generateCGULabel(): void {
        this.cguString = this.isFr ? "Accepter nos " : "Accept our ";
        this.cguString += "<a href=\"" + window.location.protocol + "//www." + window.location.href.split(".")[1] + ".com/rgpd/utilisation\" target='_blank'>";
        this.cguString += this.isFr ? "Conditions d'utilisation" : "Conditions of use";
        this.cguString += "</a>";
        this.cguString += this.isFr ? ", notre " : ", our ";
        this.cguString += "<a href=\"" + window.location.protocol + "//www." + window.location.href.split(".")[1] + ".com/rgpd/confidentialite\" target='_blank'>";
        this.cguString += this.isFr ? "Politique de confidentialité" : "Privacy Policy";
        this.cguString += "</a>";
        this.cguString += this.isFr ? " et notre " : "and our ";
        this.cguString += "<a href=\"" + window.location.protocol + "//www." + window.location.href.split(".")[1] + ".com/rgpd/cookie\" target='_blank'>";
        this.cguString += this.isFr ? "Utilisation des cookies " : "Use of cookies";
        this.cguString += "</a> *";
    }

    isRequired(champ: string): boolean {
        if (this.modelForm.controls.profil.value) {
            let profil = this.modelForm.controls.profil.value.champs;
            return profil.indexOf(champ) !== -1;
        }
        return false;
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/popin-compte/popin-compte.component.ts